module.exports = __webpack_public_path__ + "static/media/house6.d81eb294.webp";